import * as React from 'react';
import '../sass/UserNavMenu.css';
import ReactTable from "react-table";
import 'react-table/react-table.css'
import '../sass/LeaderboardComponent.css';
import { db, auth } from '../firebase/firebase';
import PlayerStatComponent from './PlayerStatComponent';


// interface leaderboardData {
//     name:string;
//     score:number;
// }

export default class Leaderboard extends React.Component<any, any> {
    
    // private leaderboardDatabaseRef:firebase.database.Reference = db.app.database().ref('scoreboard');
    private i:number = 0;
    private leaderboard:Array<any> = []

    constructor(props:any) {
        super(props);

        this.state = {
            playerdata: [],
            data: [],
            columns: [
                {
                    accessor: "position",
                    className: 'leaderboard_PositionColumn',
                    width: 50,
                },
                {
                    accessor: "name",
                    className: 'leaderboard_NameColumn',
                },
                {
                    accessor: "score",
                    className: 'leaderboard_ScoreColumn',
                    headerClassName: 'leaderboard_ScoreColumnHeader',
                }
            ]
        }

        this.updateData = this.updateData.bind(this);
    }

    public componentDidMount() {
        this.setData();
    }

    private dataRead() {
        console.log("Data read")
    }

    private updateData(e:any) {
        console.log("[Leaderboard] Updating leaderboard data:", auth.currentUser.uid, e.key)
        let data = e.val();
        this.i++;
        let score = {
            position: this.i,
            name: data.name,
            score: data.score * -1,
        }
        this.leaderboard.push(score)
        if (auth.currentUser.uid == e.key) {
            console.log("[Leaderboard] Setting player data:", auth.currentUser.uid, e.key, this.i, data.name, data.score)
            let playerdata = [{
                position: this.i,
                name: data.name,
                score: data.score * -1,
            }]
            this.props.setPlayerPosition(this.i);
            this.setState({data: this.leaderboard, playerdata: playerdata});
            return;
        }
        this.setState({data: this.leaderboard});
    }

    private setData():any {
        if (this.props.leaderboardDatabaseRef != null) {
            // let queryRef:firebase.database.Query = this.props.leaderboardDatabaseRef.orderByChild("score").limitToLast(10).on("value", this.updateData);
            
            // this.queryRef.on('value', this.onAppDatabaseUpdated);
            // let data = []
            // let i = 0;
            var playerdata:Array<any> = [{
                name: this.props.userData.firstName + " " + this.props.userData.lastName,
                score: this.props.userData.highscore,
            }];
            this.setState({data: this.leaderboard, playerdata: playerdata});
            let queryRef:firebase.database.Query = this.props.leaderboardDatabaseRef.orderByChild("score").limitToLast(100).on("child_added", this.updateData);
        }
    }

    render() {
        return (
            <div id='leaderboard'>
                {
                    this.props.showPlayerScore ?
                    <ReactTable
                        className="playerScore"
                        data={this.state.playerdata}
                        columns={this.state.columns}
                        showPagination={false}
                        showPaginationTop={false}
                        showPaginationBottom={false}
                        showPageSizeOptions={false}
                        defaultPageSize={1}
                    /> : null
                }
                {
                    this.props.showPlayerStat ? <PlayerStatComponent settings={this.props.settings} userData={this.props.userData}/> : null
                }
                {
                    this.props.showLeaderboard ? 
                    <ReactTable
                        data={this.state.data}
                        columns={this.state.columns}
                        showPagination={false}
                        showPaginationTop={false}
                        showPaginationBottom={false}
                        showPageSizeOptions={false}
                        defaultPageSize={5}
                    /> : null
                }
                
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Leaderboard.tsx